/* DNAM Brands — interaction layer. No dependencies. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header ---------- */
  function header() {
    var hdr = document.querySelector('[data-hdr]');
    if (!hdr) return;
    var hero = document.querySelector('[data-hero]');
    var last = 0;

    var ann = document.querySelector('.ann');
    function setH() {
      document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px');
      var ah = ann ? ann.offsetHeight : 0;
      document.documentElement.style.setProperty('--ann-h', ah + 'px');
      document.body.classList.toggle('has-ann', !!ann);
    }
    setH();
    window.addEventListener('resize', setH);

    function onScroll() {
      var y = window.scrollY || 0;
      if (ann) {
        var ah = ann.offsetHeight;
        ann.style.transform = 'translateY(' + (-Math.min(y, ah)) + 'px)';
        hdr.style.top = Math.max(0, ah - y) + 'px';
      }
      var threshold = hero ? hero.offsetHeight - hdr.offsetHeight - 8 : 24;
      hdr.setAttribute('data-mode', hero && y < threshold ? 'over' : 'solid');
      // hide on scroll down, reveal on up (only past the fold)
      if (!document.body.classList.contains('nav-open')) {
        if (y > last && y > 420) hdr.classList.add('is-hidden');
        else hdr.classList.remove('is-hidden');
      }
      last = y;
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile drawer ---------- */
  function drawer() {
    var btn = document.querySelector('[data-burger]');
    var dr = document.querySelector('[data-drawer]');
    if (!btn || !dr) return;
    function close() {
      document.body.classList.remove('nav-open');
      btn.setAttribute('aria-expanded', 'false');
      dr.setAttribute('aria-hidden', 'true');
    }
    btn.addEventListener('click', function () {
      var open = document.body.classList.toggle('nav-open');
      btn.setAttribute('aria-expanded', String(open));
      dr.setAttribute('aria-hidden', String(!open));
    });
    dr.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('nav-open')) close();
    });
  }

  /* ---------- reveal + counters ----------
     A rAF-throttled scroll check rather than IntersectionObserver: IO can silently
     skip elements during fast scrolling, which left whole sections invisible. */
  var watched = [];

  function fmtCount(v, el) {
    var dec = el.getAttribute('data-dec') === 'true';
    var group = el.getAttribute('data-group') !== 'false';
    var n = dec ? Math.round(v * 10) / 10 : Math.round(v);
    return group ? n.toLocaleString('en-US') : String(n);
  }

  function runCount(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    if (reduce) { el.textContent = fmtCount(target, el); return; }
    var dur = 1500, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      el.textContent = fmtCount(target * (1 - Math.pow(1 - p, 4)), el);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = fmtCount(target, el);
    }
    requestAnimationFrame(step);
  }

  function collect() {
    watched = [];
    document.querySelectorAll('.rv, .clip').forEach(function (el) {
      if (!el.classList.contains('in')) watched.push({ el: el, kind: 'rv' });
    });
    document.querySelectorAll('[data-count]').forEach(function (el) {
      if (el.getAttribute('data-counted') === '1') return;
      if (reduce) {
        el.textContent = fmtCount(parseFloat(el.getAttribute('data-count')) || 0, el);
        el.setAttribute('data-counted', '1');
        return;
      }
      el.textContent = '0';
      watched.push({ el: el, kind: 'count' });
    });
  }

  function check() {
    if (!watched.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var still = [];
    for (var i = 0; i < watched.length; i++) {
      var w = watched[i], r = w.el.getBoundingClientRect();
      // fire once the element reaches 92% of the viewport, or if it is already past
      var hit = (r.top < vh * 0.92 && r.bottom > 0) || r.bottom <= 0;
      if (!hit) { still.push(w); continue; }
      if (w.kind === 'rv') w.el.classList.add('in');
      else { w.el.setAttribute('data-counted', '1'); runCount(w.el); }
    }
    watched = still;
  }

  var ticking = false;
  function onFrame() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; check(); });
  }

  function reveal() {
    collect();
    if (reduce) {
      watched.forEach(function (w) { if (w.kind === 'rv') w.el.classList.add('in'); });
      watched = [];
      return;
    }
    check();
    window.removeEventListener('scroll', onFrame);
    window.addEventListener('scroll', onFrame, { passive: true });
    window.addEventListener('resize', onFrame);
    // safety net for late-loading media that shifts the layout
    window.setTimeout(check, 400);
    window.setTimeout(check, 1500);
  }

  /* ---------- capabilities accordion ---------- */
  function caps() {
    document.querySelectorAll('[data-caps]').forEach(function (list) {
      var items = list.querySelectorAll('[data-cap]');
      items.forEach(function (item) {
        var btn = item.querySelector('.cap__btn');
        var panel = item.querySelector('.cap__panel');
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var open = item.getAttribute('data-open') === 'true';
          if (list.getAttribute('data-single') !== 'false') {
            items.forEach(function (o) {
              o.setAttribute('data-open', 'false');
              var b = o.querySelector('.cap__btn');
              if (b) b.setAttribute('aria-expanded', 'false');
            });
          }
          item.setAttribute('data-open', String(!open));
          btn.setAttribute('aria-expanded', String(!open));
        });
      });
    });
  }

  /* ---------- portfolio filter ---------- */
  function portfolio() {
    document.querySelectorAll('[data-pf]').forEach(function (root) {
      var btns = root.querySelectorAll('[data-filter]');
      var cards = root.querySelectorAll('[data-type]');
      var count = root.querySelector('[data-pf-count]');
      var empty = root.querySelector('[data-pf-empty]');

      /* no filter bar means nothing to filter — leave the rendered count alone */
      if (!btns.length) { return; }

      function apply(val) {
        var shown = 0;
        cards.forEach(function (c) {
          var match = val === 'all' || c.getAttribute('data-type') === val;
          if (match) shown++;
          c.classList.toggle('is-out', !match);
          window.setTimeout(function () { c.hidden = !match; }, match ? 0 : 420);
          if (match) c.hidden = false;
        });
        if (count) count.textContent = shown + (shown === 1 ? ' Brand' : ' Brands');
        if (empty) empty.hidden = shown !== 0;
        btns.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-filter') === val));
        });
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () { apply(b.getAttribute('data-filter')); });
      });
      var initial = root.getAttribute('data-pf') || 'all';
      apply(initial);
    });
  }

  /* ---------- marquee: duplicate track for seamless loop ---------- */
  function marquee() {
    document.querySelectorAll('[data-marquee]').forEach(function (m) {
      var track = m.querySelector('.marquee__track');
      var grp = track && track.querySelector('.marquee__grp');
      if (!track || !grp) return;
      // ensure the group is at least as wide as the viewport, then mirror it
      var vpW = m.offsetWidth;
      var guard = 0;
      while (grp.offsetWidth < vpW && guard < 6) {
        grp.innerHTML += grp.innerHTML;
        guard++;
      }
      var clone = grp.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      var speed = parseFloat(m.getAttribute('data-speed')) || 55;
      track.style.setProperty('--dur', (grp.offsetWidth / speed) + 's');
    });
  }

  /* ---------- headline: weight follows the cursor ----------
     Splits the line into characters once, then interpolates the variable font
     weight by distance from the pointer. No transforms, no layout thrash. */
  function liveType() {
    var roots = document.querySelectorAll('[data-livetype]');
    if (!roots.length || reduce) return;
    if (window.matchMedia('(hover: none)').matches) return;

    var chars = [];
    roots.forEach(function (root) {
      root.querySelectorAll('.clip__i, .lt-line').forEach(function (line) {
        if (line.__split) return;
        line.__split = true;
        var words = line.textContent.split(/(\s+)/);
        line.textContent = '';
        words.forEach(function (w) {
          if (!w) return;
          if (/^\s+$/.test(w)) { line.appendChild(document.createTextNode(' ')); return; }
          var ws = document.createElement('span');
          ws.className = 'lt-w';
          for (var i = 0; i < w.length; i++) {
            var cs = document.createElement('span');
            cs.className = 'lt-c';
            cs.textContent = w[i];
            ws.appendChild(cs);
            chars.push({ el: cs, w: 600, t: 600, x: 0, y: 0 });
          }
          line.appendChild(ws);
        });
      });
    });
    if (!chars.length) return;

    var host = roots[0].closest('section') || roots[0];
    var mx = -9999, my = -9999, running = false, idle = 0;

    function measure() {
      for (var i = 0; i < chars.length; i++) {
        var r = chars[i].el.getBoundingClientRect();
        chars[i].x = r.left + r.width / 2;
        chars[i].y = r.top + r.height / 2;
      }
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', measure, { passive: true });

    var RADIUS = 220, MIN = 500, MAX = 900;
    function tick() {
      var moving = false;
      for (var i = 0; i < chars.length; i++) {
        var c = chars[i];
        var d = Math.hypot(c.x - mx, c.y - my);
        var f = d < RADIUS ? 1 - d / RADIUS : 0;
        c.t = MIN + (MAX - MIN) * (f * f);
        c.w += (c.t - c.w) * 0.18;
        if (Math.abs(c.t - c.w) > 0.6) moving = true;
        c.el.style.fontVariationSettings = '"wght" ' + Math.round(c.w);
      }
      if (moving || idle < 30) { idle++; requestAnimationFrame(tick); }
      else running = false;
    }
    function kick() { idle = 0; if (!running) { running = true; requestAnimationFrame(tick); } }

    host.addEventListener('pointermove', function (e) { mx = e.clientX; my = e.clientY; kick(); });
    host.addEventListener('pointerleave', function () { mx = my = -9999; kick(); });
  }

  /* ---------- footprint: link the location list to the map ---------- */
  function footprint() {
    document.querySelectorAll('.fp').forEach(function (root) {
      var rows = root.querySelectorAll('.loc[data-loc]');
      var nodes = root.querySelectorAll('.fp__node[data-loc]');
      if (!rows.length || !nodes.length) return;
      function set(id, on) {
        rows.forEach(function (r) { if (r.getAttribute('data-loc') === id) r.classList.toggle('is-on', on); });
        nodes.forEach(function (n) { if (n.getAttribute('data-loc') === id) n.classList.toggle('is-on', on); });
      }
      rows.forEach(function (r) {
        var id = r.getAttribute('data-loc');
        r.addEventListener('mouseenter', function () { set(id, true); });
        r.addEventListener('mouseleave', function () { set(id, false); });
      });
      nodes.forEach(function (n) {
        var id = n.getAttribute('data-loc');
        n.addEventListener('mouseenter', function () { set(id, true); });
        n.addEventListener('mouseleave', function () { set(id, false); });
        n.addEventListener('focus', function () { set(id, true); });
        n.addEventListener('blur', function () { set(id, false); });
      });
    });
  }

  /* ---------- contact form: reflect inquiry type in the subject ---------- */
  function contactForm() {
    document.querySelectorAll('[data-contact-form]').forEach(function (form) {
      var sel = form.querySelector('[data-route]');
      var subject = form.querySelector('[data-subject]');
      if (!sel || !subject) return;
      function sync() {
        subject.value = 'DNAM Website — ' + sel.value + ' inquiry';
      }
      sel.addEventListener('change', sync);
      sync();
    });
  }

  function init() {
    header(); drawer(); reveal(); caps(); portfolio(); marquee(); footprint(); liveType(); contactForm();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Shopify theme editor re-renders sections; re-bind.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
